(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);
	}
//remove after the test finishes
	function removeHiddenAbTestSlides() {
		document.querySelectorAll('.swiper-wrapper ab-test-video').forEach(function (el) {
			if (window.getComputedStyle(el).display === 'none') {
				el.remove();
			}
		});
		document.querySelectorAll('.swiper-wrapper .product-media-modal__item[data-media-id*="ab-test-video"]').forEach(function (el) {
			if (window.getComputedStyle(el).display === 'none') {
				el.remove();
			}
		});
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});
//remove after the test finishes
window.addEventListener('ig:ready', function () {
	removeHiddenAbTestSlides();
	swiperInit();
  });
})();
